export const PICKUP_TYPE_PLAN = [
    { id: "DAP", description: "Each day UPS is open", translatedDescription: 'upplm.pickupdetails.pickuptypeplan.dap' },
    { id: "DSP", description: "On specific days of the week", translatedDescription: 'upplm.pickupdetails.pickuptypeplan.dsp' },
    { id: "SMP", description: "Only when I request a pickup", translatedDescription: 'upplm.pickupdetails.pickuptypeplan.smp' }
];

export const DAY_OF_WEEK = {
    SUNDAY: '01',
    MONDAY: '02',
    TUESDAY: '03',
    WEDNESDAY: '04',
    THURSDAY: '05',
    FRIDAY: '06',
    SATURDAY: '07'
};

export const DAYCODE_TRANSLATION = [
    { daycode: '02', key: 'upplm.pickupdetails.monday' },
    { daycode: '03', key: 'upplm.pickupdetails.tuesday' },
    { daycode: '04', key: 'upplm.pickupdetails.wednesday' },
    { daycode: '05', key: 'upplm.pickupdetails.thursday' },
    { daycode: '06', key: 'upplm.pickupdetails.friday' },
    { daycode: '07', key: 'upplm.pickupdetails.saturday' },
];

export const DAYS_SHORTCODE_TRANSLATION = [
    {dayshortcode:'MON', key: 'upplm.pickupdetails.monday' },
    {dayshortcode:'TUE', key: 'upplm.pickupdetails.tuesday' },
    {dayshortcode:'WED', key: 'upplm.pickupdetails.wednesday' },
    {dayshortcode:'THU', key: 'upplm.pickupdetails.thursday' },
    {dayshortcode:'FRI', key: 'upplm.pickupdetails.friday' },
    {dayshortcode: 'SAT', key: 'upplm.pickupdetails.saturday' },
];

export const PICKUP_TYPE_TEXT_MESSAGE = [
    { id: 'SMP', text: 'UPS Smart Pickup®', translationKey: 'upplm.common.smp' },
    { id: 'DSP', text: 'Day-Specific Pickup', translationKey: 'upplm.pickupdetails.dsp' },
    { id: 'DAP', text: 'Daily Pickup', translationKey: 'upplm.common.dap' },
    { id: "-1", text: '' }
];

export const SMART_PICKUP_NOTE = "For same day pickup, request service at least one hour before your Preferred Time"

export const PICKUP_TYPE = {
    SMP: 'SMP',
    DSP: 'DSP',
    DAP: 'DAP'
};

export const LAPSE_TIME_INCREMENT = 15;

export const SCHEDULE_ERROR_MESSAGES = [
    //No Preferred Time set
    { code: 'SMP_DAP_1', key: 'upplm.pickupdetails.error.smp_dap_1' },
    //No Latest Time set
    { code: 'SMP_DAP_2', key: 'upplm.pickupdetails.error.smp_dap_2'},
    //No Preferred Time AND no Latest Time set
    { code: 'SMP_DAP_3', key: 'upplm.pickupdetails.error.smp_dap_3'},
    { code: 'SMP_DAP_4', key: 'upplm.pickupdetails.error.smp_dap_4'},
    { code: 'SMP_DAP_5', key: 'upplm.pickupdetails.error.smp_dap_5'},
    //No day selector checked AND no Preferred Time set
    { code: 'DSP_1',  key: 'upplm.pickupdetails.error.dsp_1' },
    //No day selector checked AND no Latest Time set
    { code: 'DSP_2',  key: 'upplm.pickupdetails.error.dsp_2' },
    //No day selector checked AND no Preferred Time AND no Latest Time set
    { code: 'DSP_3',  key: 'upplm.pickupdetails.error.dsp_3' },
    //Day Specific: saturday is geographically available, user checks Saturday checkbox but does not set a Preferred Time
    { code: 'DSP_4',  key: 'upplm.pickupdetails.error.dsp_4' },
    //Day Specific: saturday is geographically available, user checks Saturday checkbox but does not set a Latest time
    { code: 'DSP_5',  key: 'upplm.pickupdetails.error.dsp_5' },
    //Day Specific: saturday is geographically available, user checks Saturday checkbox but does not set a Preferred AND Latest times
    { code: 'DSP_6',  key: 'upplm.pickupdetails.error.dsp_6' },
    //Day Specific: user checks any day(s) checkbox(es) but does not set a Preferred Time
    { code: 'DSP_7',  key: 'upplm.pickupdetails.error.dsp_7' },
    //Day Specific: user checks any day(s) checkbox(es) but does not set a Latest Time
    { code: 'DSP_8',  key: 'upplm.pickupdetails.error.dsp_8' },
    //Day Specific: user checks any day(s) checkbox(es) but does not set a Preferred AND Latest times
    { code: 'DSP_9',  key: 'upplm.pickupdetails.error.dsp_9' },
    //Day Specific: user checks a Preferred Time and Latest Time but does not check the business day checkbox
    { code: 'DSP_10',  key: 'upplm.pickupdetails.error.dsp_10' },
    //Day Specific: user checks a Preferred Time but does not check a Latest Time AND does not check the business day checkbox
    { code: 'DSP_11',  key: 'upplm.pickupdetails.error.dsp_10' },
    //Day Specific: user checks a Latest Time but does not check a Preferred Time AND does not check the business day checkbox
    { code: 'DSP_12',  key: 'upplm.pickupdetails.error.dsp_10' },
    //Day Specific: user checks a Preferred Time and Latest Time but does not check the Saturday day checkbox
    { code: 'DSP_13',  key: 'upplm.pickupdetails.error.dsp_11' },
    //Day Specific: user checks a Preferred Time but does not check a Latest Time AND does not check the Saturday day checkbox
    { code: 'DSP_14',  key: 'upplm.pickupdetails.error.dsp_11' },
    //Day Specific: user checks a Latest Time but does not check a Preferred Time AND does not check the Saturday day checkbox
    { code: 'DSP_15',  key: 'upplm.pickupdetails.error.dsp_11' },
    //If only one day is selected, it must be a business day and NOT Saturday.
    { code: 'DSP_16',  key: 'upplm.pickupdetails.error.dsp_12' }
]

export const DAY_OF_WEEK_SHORTCODE =
{
    MON: 'MON',
    TUE: 'TUE',
    WED: 'WED',
    THU: 'THU',
    FRI: 'FRI',
    SAT: 'SAT'
};

export const DAYS_SHORTCODE_DAYWEEK = [
    { dayshortcode: 'MON', key: '02' },
    { dayshortcode: 'TUE', key: '03' },
    { dayshortcode: 'WED', key: '04' },
    { dayshortcode: 'THU', key: '05' },
    { dayshortcode: 'FRI', key: '06' },
    { dayshortcode: 'SAT', key: '07' },
];
